import { ILookup } from "./Ilookup"

export interface IKeyValue {
  key: string,
  value: string
}

export const LookupMapper = {
  toKeyValue(v?: ILookup | null): IKeyValue | null {
    if (!v) return null;
    return { key: v.id, value: v.value };
  },

  toLookup(v?: IKeyValue | null): ILookup | null {
    if (!v) return null;
    return { id: v.key, value: v.value };
  }
};